import { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { shutdown } from '@intercom/messenger-js-sdk';
import { QueryClient } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { storage } from '../services/storage/storage';

export const TOKENS_STORAGE_KEY = 'fma-tokens';

export const updateTokens = (queryClient: QueryClient, newTokens: LoginOutput) => {
  queryClient.cancelQueries(queryKeys.tokens());
  queryClient.setQueryData(queryKeys.tokens(), newTokens);
};

export const clearTokens = async (queryClient: QueryClient) => {
  storage.removeItem(TOKENS_STORAGE_KEY);
  queryClient.setQueryData(queryKeys.tokens(), null);
  queryClient.removeQueries(queryKeys.user.root());
  shutdown();
};

export const generateRandomPassword = () => {
  const positions = Array.from({ length: 16 }).map(_ => 'a');
  positions[0] = 'l';
  positions[1] = 'u';
  positions[2] = 'n';

  // Shuffle array
  for (let i = positions.length - 1; i > 0; i--) {
    const j = getRandomNumber(0, i);
    [positions[i], positions[j]] = [positions[j], positions[i]];
  }

  const lowercaseCharSet = 'abcdefghijklmnopqrstuvwxyz';
  const uppercaseCharSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numberCharSet = '0123456789';
  const allCharSet = `${lowercaseCharSet}${uppercaseCharSet}${numberCharSet}`;

  return positions
    .map(type => {
      let charSet = allCharSet;

      if (type === 'l') {
        charSet = lowercaseCharSet;
      } else if (type === 'u') {
        charSet = uppercaseCharSet;
      } else if (type === 'n') {
        charSet = numberCharSet;
      }

      return charSet.charAt(getRandomNumber(0, charSet.length));
    })
    .join('');
};
export const getRandomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
